import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToTopInstant } from "../../utils/scroll";

function ScrollToTopOnNavigate() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    scrollToTopInstant();
  }, [pathname]);

  return null;
}

export default ScrollToTopOnNavigate;
